import React, { forwardRef } from 'react'
import DOMPurify from 'dompurify'

const RichTextDisplayer = ({ richText, options, ...rest }, ref) => {
  return (
    <div
      ref={ref}
      {...rest}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(richText, options),
      }}
    />
  )
}

export default forwardRef(RichTextDisplayer)

export const removeTags = (text) =>
  text &&
  DOMPurify.sanitize(text, {
    ALLOWED_TAGS: [
      /* None! */
    ],
  })
